module.exports = __webpack_public_path__ + "5d07b6095d41f3eb65147b947c12ebce.pdf";